import { gql } from "@apollo/client";

const deleteCompanyAndProductsMutation = gql`
  mutation deleteCompanyAndProducts($id: uuid!, $productId: [uuid!]!) {
    updateCompanyByPk(pk_columns: { id: $id }, _set: { deletedAt: "now()" }) {
      id
    }
    updatePostalAddress(where: { companyId: { _eq: $id } }, _set: { deletedAt: "now()" }) {
      returning {
        id
      }
    }
    updateContactDetails(where: { companyId: { _eq: $id } }, _set: { deletedAt: "now()" }) {
      returning {
        id
      }
    }
    updateDmoArea(where: { companyId: { _eq: $id } }, _set: { deletedAt: "now()" }) {
      returning {
        id
      }
    }
    updateProductGroupProduct(
      where: { productId: { _in: $productId } }
      _set: { deletedAt: "now()" }
    ) {
      affected_rows
    }
    updateProduct(where: { id: { _in: $productId } }, _set: { deletedAt: "now()" }) {
      returning {
        id
      }
    }
  }
`;

export type DeleteCompanyAndProductsVariables = {
  id: string;
  productId: string[];
};

export type DeleteCompanyAndProductsMutationResult = {
  updateCompanyByPk: {
    id: string;
  };
  updateProduct: {
    returning: {
      id: string;
    }[];
  };
};

export default deleteCompanyAndProductsMutation;
